import BaseApiManager from './BaseApiManager';

/**
 * Curator API Manager.
 */
export default class CuratorApiManager extends BaseApiManager {
  /**
   * Create entity.
   *
   * @param {String} username
   * @param {String} displayName
   * @param {String} password
   * @param {String} passwordConfirmation
   *
   * @returns {Promise<any>}
   */
  async create({username, displayName, password, passwordConfirmation}) {
    return await this.axios.post(`${this.url}`, {
      username,
      displayName,
      password,
      passwordConfirmation
    });
  }

  /**
   * Update entity.
   *
   * @param {Number} id
   * @param {String} username
   * @param {String} displayName
   * @param {String} password
   * @param {String} passwordConfirmation
   *
   * @returns {Promise<any>}
   */
  async update({id, username, displayName, password, passwordConfirmation}) {
    return await this.axios.put(`${this.url}/${id}`, {
      username,
      displayName,
      password,
      passwordConfirmation
    })
  }

  /**
   * Check access to client.
   *
   * @param {Number} curatorId
   * @returns {Promise<AxiosPromise<any>>}
   */
  async hasAccess(curatorId) {
    return this.axios.get(`${this.url}/${curatorId}/access`)
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/api/managers/CuratorApiManager.ts